import React from "react";
import {
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Subtitle1,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { SignOut24Regular, Navigation24Regular } from "@fluentui/react-icons";

export interface HeaderProps {
  title: string;
  logo: string;
  onSignOut: () => void;
  onGoToDashboard?: () => void;
}

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "16px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    justifyContent: "space-between",
  },
  menuButton: {
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalS,
    gap: tokens.spacingHorizontalS,
  },
});

const Header: React.FC<HeaderProps> = ({ title, logo, onSignOut, onGoToDashboard }) => {
  const styles = useStyles();

  return (
    <header className={styles.header}>
      <Menu>
        <MenuTrigger>
          <MenuButton
            appearance="transparent"
            className={styles.menuButton}
            icon={<Image width="28" height="28" src={logo} alt={title} />}
          >
            <Subtitle1 as="span">{title}</Subtitle1>
          </MenuButton>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {onGoToDashboard && (
              <MenuItem icon={<Navigation24Regular />} onClick={onGoToDashboard}>
                Go to dashboard
              </MenuItem>
            )}
            <MenuItem icon={<SignOut24Regular />} onClick={onSignOut}>
              Sign out
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </header>
  );
};

export default Header;
